import React from 'react';
import ProjectTemplateAutoAssignmentRuleSelect from './ProjectTemplateAutoAssignmentRuleSelect';
import useStates from 'common/hooks/useStates';

const ProjectTemplateAutoAssignmentRuleStateSelect = props => {
  const {
    className,
    'data-test-id': dataTestId,
    label,
    onChange,
    stateId,
    projectCountryId,
  } = props;
  const { data: states, loading } = useStates(projectCountryId);
  const stateOptions = states?.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
  return (
    <ProjectTemplateAutoAssignmentRuleSelect
      isLoading={loading}
      label={label}
      options={stateOptions || []}
      value={stateId}
      onChange={stateId => onChange(states.find(({ id }) => id === stateId))}
      data-test-id={dataTestId}
      className={className}
    />
  );
};

export default ProjectTemplateAutoAssignmentRuleStateSelect;
